<template>
  <div>
    <div class="large-8 columns content__column">
        <template v-if="!testSite">
            <h2>Velkommen til meldingstjenesten!</h2>
            <p><em>Tjenesten er anonym, og du behøver ikke oppgi personlige opplysninger.</em></p>
            <p><strong>Vennligst logg deg inn.</strong></p>
            <br>
        </template>
        <template v-else>
            <h2>Testside for meldingstjenesten</h2>
            <p><strong>Vennligst logg deg inn for å skrive en melding.</strong></p>
            <br>
        </template>

      <div v-if="unauthorized" class="form__errors">
        Feil brukernavn eller passord
      </div>

      <div class="row form">
        <div class="form__field small-12 medium-7 columns">
          <label class="form__label">
            Brukernavn <span class="form__required">*</span>
            <input type="text" name="username" maxlength="255" required autofocus v-model="username" v-on:keyup.enter="login" v-validate="'required'" data-vv-as="Brukernavn">
            <span v-show="errors.has('username')" class="form__field__error">{{ errors.first('username') }}</span>
          </label>
        </div>
        <div class="form__field small-12 medium-7 columns">
          <label class="form__label">
            Passord <span class="form__required">*</span>
            <input type="password" name="password" maxlength="255" required v-model="password" v-on:keyup.enter="login" v-validate="'required'" data-vv-as="Passord">
            <span v-show="errors.has('password')" class="form__field__error">{{ errors.first('password') }}</span>
          </label>
        </div>
        <p class="small-12 large-7 columns">
          <router-link :to="{ name: 'RecoverPassword' }">Hjelp! Jeg har glemt passordet mitt.</router-link>
        </p>
        <div class="form__submit small-12 large-7 columns">
            <button @click.prevent="login" class="button form__submit__button">Logg inn</button>
        </div>
      </div>
      <p>
        Hvis du vil bruke SOS-meldingene, må du registrere deg som bruker.<br>
        Da får du din egen "postkasse" på nettsidene til Kirkens SOS.<br>
        For å lese svarene fra Kirkens SOS, logger du deg så inn på denne siden.</p>
      <ul>
        <li><router-link :to="{ name: 'Register'}">Her kan du registrere deg som ny bruker.</router-link></li>
        <li><a href="https://www.kirkens-sos.no/Krisetjenester/SOS_meldinger/Mer_om_SOS_meldinger___/index.html">Her finner du informasjon om SOS-meldinger</a>.</li>
      </ul>
    </div>
    <div class="large-4 columns content__aside content__aside--aligned" v-if="!testSite">
      <h3>Om SOS-meldinger</h3>
      <p class="txt"><a href="https://www.kirkens-sos.no/Krisetjenester/SOS_meldinger/Mer_om_SOS_meldinger___/index.html">Vil du vite mer om SOS-meldingene.</a></p>

      <h3>Virker ikke SOS-meldinger på din maskin?</h3>
      <p class="txt">Hvis du har problemer med å logge deg inn på SOS-meldingtjenesten, kan grunnen være at sikkerhetsinnstillingene på din nettleser står for høyt. <a href="https://www.kirkens-sos.no/Artikler/307.html">Få tips til hvordan du kan få  SOS-meldingen til å virke.</a></p>

      <h3>Tilbakemelding på krisetjenesten</h3>
      <p class="txt">Vi er mennesker på Kirkens SOS og mennesker kan gjøre feil. Vi ønsker at du gir oss beskjed dersom du ikke er fornøyd med måten du ble møtt på når du kontaktet Kirkens SOS. <a href="https://www.kirkens-sos.no/Krisetjenester/Tilbakemelding_p__krisetjenesten/index.html">Gi oss tilbakemelding på tjenestene våre.</a></p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: '',
      password: '',

      unauthorized: false,
    }
  },
  created() {
      var _this = this;
      this.$auth.ready(function () {

      });
  },
  computed: {
        testSite() {
            return process.env.TEST || false;
        },
  },
  methods: {
    login(){
        var _this = this;
        this.$validator.validateAll().then(isValid => {
            if(isValid) {

              _this.$auth.login({
                  url : '/caller/login',
                  data: {
                      username: _this.username,
                      password: _this.password
                  },
                  success: function (response) {
                  },
                  error: function (response) {
                    _this.unauthorized = true;
                  },
                  rememberMe: true,
                  redirect: '/',
                  fetchUser: true,
              });
            }
        });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Login.vue